import { render, staticRenderFns } from "./BaseCourses.vue?vue&type=template&id=7204cdd0&scoped=true&"
import script from "./BaseCourses.vue?vue&type=script&lang=js&"
export * from "./BaseCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7204cdd0",
  null
  
)

export default component.exports